import { render, staticRenderFns } from "./userpage.vue?vue&type=template&id=a49ec1e2&"
import script from "./userpage.vue?vue&type=script&lang=js&"
export * from "./userpage.vue?vue&type=script&lang=js&"
import style0 from "./userpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports